import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const LockClosedIcon = ({
    width = 24,
    height = 24,
    color = themeColors.grey,
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 10V8C7 5.79 8.79 4 11 4H13C15.21 4 17 5.79 17 8V10"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="6"
                y="10"
                width="12"
                height="10"
                rx="2"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path d="M12 14.5V16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
